import React from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import normalize from "app/utils/normalize";
import ArrowRightSlider from "app/components/Icons/ArrowSlider/ArrowRightSlider";
import Animated, { FadeInUp } from "react-native-reanimated";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import ChangeIcon from "app/components/common/Icons/RefreshIcon";
import theme from "app/Theme/Theme";

const ReanimatedBox = isWeb ? Box : Animated.createAnimatedComponent(Box);

interface Props {
  onPress: () => void;
  buttonText: string;
}

const CancelActionBar = ({ onPress, buttonText }: Props) => {
  return (
    <ReanimatedBox
      entering={FadeInUp.delay(855).springify().damping(12)}
      left={isWeb ? 0 : theme.spacing["xm"]}
      zIndex={9}
      bottom={{ phone: -normalize(48), smallWeb: 0 }}
      position={{ phone: "absolute", smallWeb: "relative" }}
      width="100%"
      backgroundColor="neutral.75"
      borderBottomEndRadius={8}
      borderBottomStartRadius={8}
      paddingTop="m"
      paddingBottom="s"
      paddingLeft="xm"
      paddingRight="sm"
    >
      <PressableOpacity
        onPress={onPress}
        style={{ alignItems: "center", flexDirection: "row" }}
      >
        <Box flex={1} alignItems="center" flexDirection="row">
          <ChangeIcon
            height={normalize(20)}
            width={normalize(20)}
            color={theme.colors["neutral.900"]}
          />
          <MainText marginLeft="s" variant="l2-medium">
            {buttonText}
          </MainText>
        </Box>
        <ArrowRightSlider color="black" />
      </PressableOpacity>
    </ReanimatedBox>
  );
};

export default CancelActionBar;
